<template>
  <BaseImage
    v-if="layout === 'stacked-compact'"
    :src="logoName"
    :alt="siteTitle"
  />
  <BaseIcon
    v-else
    :name="logoName"
    :alt="siteTitle"
    size="size-full"
  />
</template>

<script setup lang="ts">
interface Props {
  layout?: 'row' | 'left-stack' | 'stacked-compact'
  locale?: 'en' | 'ja'
  alt?: string
}

const props = withDefaults(defineProps<Props>(), {})

const { siteName } = useSite()
const siteTitle = props.alt ?? siteName()

const compactLogoPathBase = 'assets/img/brand/logo-sq-4c-txt-hina'

const { isEn } = useI18n()
const suffix = computed(() => {
  const locale = props.locale ?? (isEn.value && 'en')
  const suffixText = locale === 'en' ? 'en' : ''
  return suffixText
})

const localePathName = (() => {
  let jaName = ''

  switch (props.layout) {
    case 'row':
      jaName = 'hina/logo-horizontal-4c-b'
      return {
        ja: jaName,
        en: `${jaName}-${suffix.value}`,
      }

    case 'stacked-compact':
      return {
        ja: getFullPath(`${compactLogoPathBase}.svg`),
        en: getFullPath(`${compactLogoPathBase}-${suffix.value}.svg`),
      }

    default:
      jaName = 'hina/logo-block'
      return {
        ja: jaName,
        en: `${jaName}-${suffix.value}`,
      }
  }
})()

const logoName = computed(() => {
  const name = isEn.value ? localePathName.en : localePathName.ja
  return name
})
</script>
